import React from "react";
import CBRCBC from "./o0c30a6b28a0bb02d3cba5cfd8121c36/CustomBigCarousel";
import CBRCSC from "./o0c30a6b28a0bb02d3cba5cfd8121c36/CustomSmallCarousel";
import CBRCIPR from "./o0c30a6b28a0bb02d3cba5cfd8121c36/CustomImagePopRow";
import type { AppContext, Size, Store } from "../../types";

interface ProgramComponentContext {
    context: AppContext;
    size: Size;
    viewportWidth: number;
    setStore?: (store: Store | null) => void;
    [key: string]: unknown;
}

type ComponentMap = Record<string, Record<string, React.ReactElement>>;

const components = (context: ProgramComponentContext): ComponentMap => ({
    CustomBigCarousel: { o0c30a6b28a0bb02d3cba5cfd8121c36: <CBRCBC {...context} /> },
    CustomSmallCarousel: { o0c30a6b28a0bb02d3cba5cfd8121c36: <CBRCSC {...context} /> },
    CustomImagePopRow: { o0c30a6b28a0bb02d3cba5cfd8121c36: <CBRCIPR {...context} /> },
});

interface ProgramSpecificProps {
    context: ProgramComponentContext;
    component: string;
}

const ProgramSpecific = ({ context, component }: ProgramSpecificProps): React.ReactElement =>
    components(context)[component][context.context.programGuid as string];

export default ProgramSpecific;
